"use strict";
const React = require('react');
const react_redux_1 = require('react-redux');
const AppBar_1 = require('material-ui/AppBar');
const IconButton_1 = require('material-ui/IconButton');
const IconMenu_1 = require('material-ui/IconMenu');
const MenuItem_1 = require('material-ui/MenuItem');
const more_vert_1 = require('material-ui/svg-icons/navigation/more-vert');
const auth_1 = require('../actions/auth');
const c = require('./theme/colors');
const mapStateToProps = (state, props) => ({
    user: state.auth.user,
    title: props.title,
});
const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(auth_1.logout()),
});
class Navigation extends React.Component {
    render() {
        const iconElementRight = this.props.rightIcon || this.renderRightMenu();
        return (React.createElement(AppBar_1.default, {iconElementLeft: this.props.leftIcon, iconElementRight: iconElementRight, showMenuIconButton: !!this.props.leftIcon, style: exports.style.appBar, title: this.props.title}));
    }
    renderRightMenu() {
        const items = this.renderRightMenuItems();
        if (items.length === 0) {
            return null;
        }
        return (React.createElement(IconMenu_1.default, {iconButtonElement: React.createElement(IconButton_1.default, null, 
            React.createElement(more_vert_1.default, null)
        ), anchorOrigin: { horizontal: 'left', vertical: 'top' }, targetOrigin: { horizontal: 'left', vertical: 'bottom' }}, items));
    }
    renderRightMenuItems() {
        let menuItems = [];
        if (this.props.user) {
            menuItems.push(React.createElement(MenuItem_1.default, {key: 0, onTouchTap: () => this.props.logout(), primaryText: "Log out"}));
        }
        return menuItems;
    }
}
Navigation.defaultProps = {
    title: 'My Minutes',
};
exports.style = {
    appBar: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '64px',
        maxWidth: '768px',
        margin: '0 auto',
    },
    appBarLink: {
        color: c.white,
        textDecoration: 'none',
    },
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Navigation);



/** WEBPACK FOOTER **
 ** ./src/components/Navigation.tsx
 **/